import { BitrixVue } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';


export const MpBanner = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number]
    },
    updated() {

    },
    mounted() {
        let interval = this.struct[this.structKey].componentData.INTERVAL * 1000;
        let progressCircle = document.querySelector(".autoplay-progress svg");
        let homeSliderNav = new Swiper(".js-homescreen-slider-nav", {
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 12,
            autoplay: {
                delay: interval,
                disableOnInteraction: true
            },
            grabCursor: true,
            watchSlidesProgress: true,
            pagination: {
                el: ".js-homescreen-bul",
                type: "bullets",
                clickable: true
            }
        });
        let homeSliderMain = new Swiper(".js-homescreen-slider", {
            loop: true,
            spaceBetween: 0,
            grabCursor: true,
            autoplay: {
                delay: interval,
                disableOnInteraction: true
            },
            thumbs: {
                swiper: homeSliderNav
            },
            pagination: {
                el: ".js-homescreen-pag",
                type: "fraction"
            },
            navigation: {
                nextEl: ".js-homescreen-btn-next",
                prevEl: ".js-homescreen-btn-prev"
            },
            breakpoints: {
                // when window width is >= 320px
                320: {
                    spaceBetween: 10,
                    pagination: {
                        type: "bullets",
                        clickable: true
                    }
                },
                991: {
                    spaceBetween: 0,
                    pagination: {
                        type: "fraction"
                    }
                }
            },
            on: {
                init: function init() {
                    $(".swiper-progress-bar").removeClass("animate");
                    $(".swiper-progress-bar").removeClass("active");
                    $(".swiper-progress-bar").eq(0).addClass("animate");
                    $(".swiper-progress-bar").eq(0).addClass("active");
                },
                slideChangeTransitionStart: function slideChangeTransitionStart() {
                    $(".swiper-progress-bar").removeClass("animate");
                    $(".swiper-progress-bar").removeClass("active");
                    $(".swiper-progress-bar").eq(0).addClass("active");
                },
                slideChangeTransitionEnd: function slideChangeTransitionEnd() {
                    $(".swiper-progress-bar").eq(0).addClass("animate");
                },
                autoplayTimeLeft: function autoplayTimeLeft(s, time, progress) {
                    progressCircle.style.setProperty("--progress", 1 - progress);
                }
            }
        });

        const revealBannerContent = function (image) {
            const slide = image.closest(".swiper-slide");
            if (!slide) {
                return;
            }

            const reveal = function () {
                if (image.naturalWidth > 0) {
                    slide.classList.add("homescreen__slide--image-ready");
                }
            };

            if (image.complete) {
                reveal();
            } else {
                image.addEventListener("load", reveal, { once: true });
            }
        };

        this.$el.querySelectorAll(".homescreen__bg picture img").forEach(revealBannerContent);
    },
    computed: {
        ...mapState(vplSiteStore, ['struct'])
    },
    template: `

<section v-if="this.struct[this.structKey].componentData.ITEMS" class="homescreen">
    <div class="homescreen__slider swiper js-homescreen-slider">
        <div class="swiper-wrapper">

            <div v-for="(item, itemIndex) in this.struct[this.structKey].componentData.ITEMS" :key="item.ID" :class="{editable: item.EDIT_BUTTON}" class="swiper-slide">
                <div class="homescreen__bg">
                    <picture>
                        <source v-if="item.MOBILE_PICTURE" :srcset="item.MOBILE_PICTURE" media="(max-width: 768px)">
                        <img :src="item.PICTURE" :alt="item.NAME" :title="item.NAME" :fetchpriority="itemIndex === 0 ? 'high' : 'auto'" :loading="itemIndex === 0 ? 'eager' : 'lazy'">
                    </picture>
                </div>
                <div class="container">
                    <ItemEditBtns v-if="item.EDIT_BUTTON" :onclick="item.EDIT_BUTTON">
                        Редактировать элемент
                    </ItemEditBtns>
                    <div
					class="homescreen__content"
					:class="{ 'homescreen__content--html': item.DETAIL_TEXT && item.DETAIL_TEXT.length }"
				>
					<div
						v-if="item.DETAIL_TEXT && item.DETAIL_TEXT.length"
						class="homescreen__html"
						v-html="item.DETAIL_TEXT"
					></div>
					<template v-else>
						<a v-if="item.LINK && item.LINK.length" :href="item.LINK" class="homescreen__title">
							{{ item.NAME }}
						</a>
						<span v-else class="homescreen__title">
							{{ item.NAME }}
						</span>

						<a
							v-if="item.BUTTON_TEXT && item.BUTTON_LINK"
							:href="item.BUTTON_LINK"
							class="homescreen__button"
						>
							{{ item.BUTTON_TEXT }}
						</a>
					</template>
				</div>
                </div>
            </div>

        </div>
    </div>
    <div class="container container--nav">
        <div class="homescreen__nav">
            <div class="homescreen__nav-slider swiper js-homescreen-slider-nav">
                <div class="swiper-wrapper">
                    <div v-for="item in this.struct[this.structKey].componentData.ITEMS" :key="item.ID + '-dot'" class="swiper-slide">
                        <div class="homescreen__nav-slide">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="slider-arrows homescreen__slider-arrows">
            <div class="swiper-button-prev slider-btn js-homescreen-btn-prev">
                <svg class="icon icon-arrow-prev"><use xlink:href="#icon-arrow-prev"></use></svg>
            </div>
            <div class="swiper-button-next slider-btn js-homescreen-btn-next">
                <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
            </div>
            <div class="autoplay-progress">
                <svg viewBox="0 0 114 54">
                    <rect x="1" y="1" width="112" height="52" rx="26"></rect>
                </svg>
            </div>
            <div class="swiper-progress-bar">
                <span class="slide_progress-bar"></span>
            </div>
        </div>
    </div>
</section>
    `
}